import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BackButton, SubTitle } from "../../Components/CustomComponents";
import { useGetTripDetailQuery } from "../../Data/services/transporterApi";
import styles from "./styles/user_management.module.scss";
import { Accordion, Badge, Card, Col, Row, Spinner } from "react-bootstrap";
import MapFixed from "../../Components/MapModal/MapFixed";
import DetailRow from "../../Components/CustomComponents/DetailRow";
import {
  formatUTCDateToLocal,
  getTripStatus,
  getTripStopStatus,
  getTripStopType,
  TRIP_STOP_TYPE_LIST,
} from "../../Helper";
import ZoomImage from "../../Components/ZoomImage";
import CustomLoader from "../../Components/CustomComponents/CustomLoader";
import { useSocket } from "../../context/SocketContext";
import { useSelector } from "react-redux";

const containerStyle = {
  width: "100%",
  height: "200px",
  borderRadius: "20px",
};

const TripDetailScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state.trip;

  const isSocketConnected = useSelector((state) => state.socket.isConnected);
  const busSpeed = useSelector((state) => state.socket.busSpeed);
  const socket = useSocket();
  // console.log(isSocketConnected);
  console.log(busSpeed);

  const [mounted, setMounted] = useState(false);
  // const [busSpeed, setBusSpeed] = useState(0);
  const [busLocation, setBusLocation] = useState({ lat: "", lng: "" });
  // console.log(editData);

  const { data: tripDetail, isLoading } = useGetTripDetailQuery({
    id: editData.id,
  });
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!socket || !isSocketConnected) return;

    // const handler = (data) => {
    //   console.log("trip_location_updated", data.speed);
    //   if (data.speed) setBusSpeed(data.speed);
    // };

    // socket.on("trip_location_updated", handler);

    socket.emit("_joinTripRoom", { trip_id: editData?.id });
    console.log("Joined trip room", editData?.id);

    return () => {
      socket.emit("_leaveTripRoom", { trip_id: editData?.id });
      console.log("Left trip room", editData?.id);
      // socket?.dispose("trip_location_updated", handler);
    };
  }, [editData.id, isSocketConnected, socket]);

  // useEffect(() => {
  //   if (tripDetail?.data?.bus_location) {
  //     setBusLocation({
  //       lat: tripDetail.data?.bus_location?.latitude,
  //       lng: tripDetail.data?.bus_location?.longitude,
  //     });
  //   }
  // }, [tripDetail]);

  if (!mounted || !editData) return null;

  return (
    <div className={styles.MainContainer}>
      <div className={styles.headerContainer}>
        <div className="d-flex flex-row gap-3">
          <BackButton
            isRelative={true}
            handleBackButton={() => {
              navigate(-1);
            }}
          />
          <SubTitle text={"Trip Details"} classes="" />
        </div>
      </div>
      <div className="w-100">
        {isLoading ? (
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            {/* <Spinner variant="primary" /> */}
            <CustomLoader />
          </div>
        ) : (
          <>
            <Row className="mb-4 w-100">
              <Col sm={8} className="">
                <h5 className="mb-3">Bus Location</h5>
                {tripDetail.data?.bus_location?.latitude &&
                tripDetail.data?.bus_location?.longitude ? (
                  <>
                    {/* <p className="m-0">
                      Heading: {tripDetail.data?.bus_location?.heading}
                    </p> */}
                    <p className="m-0 mb-2">
                      {/* Speed: {tripDetail.data?.bus_location?.speed} km */}
                      Speed: {Number(busSpeed || 0).toFixed(2)} km
                    </p>
                    <div className="w-100 p-2 bg-white rounded-2">
                      <MapFixed
                        isDirection={true}
                        hasMarker={true}
                        route_id={Number(tripDetail?.data?.id)}
                        trip_type={tripDetail?.data?.type}
                        direction={{
                          origin: {
                            id: Number(tripDetail?.data.stops?.[0].id),
                            lat: parseFloat(
                              tripDetail?.data?.stops[0].latitude
                            ),
                            lng: parseFloat(
                              tripDetail?.data?.stops[0].longitude
                            ),
                            type: tripDetail?.data?.stops[0].type,
                            status: tripDetail?.data?.stops[0].status,
                          },
                          destination: {
                            id: Number(
                              tripDetail?.data?.stops[
                                tripDetail?.data?.stops.length - 1
                              ].id
                            ),
                            lat: parseFloat(
                              tripDetail?.data?.stops[
                                tripDetail?.data?.stops.length - 1
                              ].latitude
                            ),
                            lng: parseFloat(
                              tripDetail?.data?.stops[
                                tripDetail?.data?.stops.length - 1
                              ].longitude
                            ),
                            type: tripDetail?.data?.stops[
                              tripDetail?.data?.stops.length - 1
                            ].type,
                            status:
                              tripDetail?.data?.stops[
                                tripDetail?.data?.stops.length - 1
                              ].status,
                          },
                          waypoints: tripDetail?.data?.stops
                            .slice(1, tripDetail?.data?.stops.length - 1)
                            ?.map((item) => ({
                              id: item.id,
                              lat: parseFloat(item.latitude),
                              lng: parseFloat(item.longitude),
                              status: item.status,
                              type: item.type,
                            })),
                        }}
                        vehicle_location={tripDetail?.data?.bus_location}
                        isGestureHandling={true}
                      />
                    </div>
                  </>
                ) : (
                  <Card
                    className="d-flex justify-content-center align-items-center"
                    style={containerStyle}
                  >
                    <span className="text-muted">
                      Bus location not available
                    </span>
                  </Card>
                )}
              </Col>

              {/* Stops Section */}

              <Col sm={4}>
                <h5 className="mb-3">Stops</h5>
                {tripDetail.data && tripDetail.data?.stops?.length > 0 ? (
                  <Accordion defaultActiveKey="0" alwaysOpen>
                    {tripDetail?.data?.stops?.map((stop, index) => (
                      <Accordion.Item
                        eventKey={index.toString()}
                        key={stop?.id}
                      >
                        <Accordion.Header>
                          {index + 1}. {stop?.name}
                        </Accordion.Header>
                        <Accordion.Body className="small">
                          <Row>
                            {/* Left Side: Stop Details */}
                            <Col md={12}>
                              <DetailRow
                                title="Location"
                                value={stop?.location}
                              />
                              <DetailRow
                                title="Sequence"
                                value={stop?.sequence}
                              />

                              <DetailRow
                                title="Scheduled Arrival"
                                value={
                                  stop?.scheduled_arrival_time
                                    ? formatUTCDateToLocal(
                                        stop?.scheduled_arrival_time
                                      )
                                    : "N/A"
                                }
                              />
                              <DetailRow
                                title="Scheduled Departure"
                                value={
                                  stop?.scheduled_departure_time
                                    ? formatUTCDateToLocal(
                                        stop?.scheduled_departure_time
                                      )
                                    : "N/A"
                                }
                              />

                              <DetailRow
                                title="Actual Arrival"
                                value={
                                  stop?.actual_arrival_time
                                    ? formatUTCDateToLocal(
                                        stop?.actual_arrival_time
                                      )
                                    : "Pending"
                                }
                              />
                              <DetailRow
                                title="Actual Departure"
                                value={
                                  stop?.actual_departure_time
                                    ? formatUTCDateToLocal(
                                        stop?.actual_departure_time
                                      )
                                    : "Pending"
                                }
                              />

                              <DetailRow
                                title="Total Students"
                                value={stop?.total_students}
                              />
                              <DetailRow
                                title="Boarded Students"
                                value={stop?.total_boarded}
                              />
                              <DetailRow
                                title="Type"
                                value={
                                  <Badge
                                    bg={
                                      stop?.type === 10 ? "success" : "danger"
                                    }
                                  >
                                    {getTripStopType(stop?.type)}
                                  </Badge>
                                }
                              />
                              <DetailRow
                                title="Status"
                                value={
                                  <Badge
                                    bg={
                                      stop?.status === 10
                                        ? "secondary"
                                        : stop?.status === 20
                                        ? "warning"
                                        : stop?.status === 30
                                        ? "success"
                                        : "danger"
                                    }
                                  >
                                    {getTripStopStatus(stop?.status)}
                                  </Badge>
                                }
                              />

                              {stop?.notes && (
                                <DetailRow title="Notes" value={stop?.notes} />
                              )}
                            </Col>

                            {/* Right Side: Stop Location Map */}
                            <Col md={12}>
                              {stop.latitude && stop.longitude ? (
                                <iframe
                                  title={`map-stop-${stop.id}`}
                                  width="100%"
                                  height="250"
                                  style={{ border: 0, borderRadius: "12px" }}
                                  loading="lazy"
                                  allowFullScreen
                                  src={`https://www.google.com/maps?q=${stop.latitude},${stop.longitude}&hl=es;z=14&output=embed`}
                                ></iframe>
                              ) : (
                                <div className="text-muted">
                                  No location available
                                </div>
                              )}
                            </Col>
                          </Row>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                ) : (
                  <span className="text-muted">No stops available</span>
                )}
              </Col>
            </Row>

            <Row className="w-100">
              {/* Trip Info */}
              <Col sm={12} md={6}>
                <h5 className="mb-3">Route Info</h5>
                <DetailRow title="Route Name" value={tripDetail.data?.name} />
                <DetailRow
                  title="Total Distance"
                  value={`${tripDetail.data?.total_distance} KM`}
                />
                <DetailRow
                  title="Total Stops"
                  value={tripDetail.data?.total_stops}
                />
                <DetailRow
                  title="Completed Stops"
                  value={tripDetail.data?.completed_stops}
                />
                <DetailRow
                  title="Total Students"
                  value={tripDetail.data?.total_students}
                />
                <DetailRow
                  title="Boarded Students"
                  value={tripDetail.data?.boarded_students}
                />
                <DetailRow
                  title="Total Time Spend"
                  value={tripDetail.data?.total_time_spend}
                />
                <DetailRow
                  title="Status"
                  value={getTripStatus(tripDetail.data?.status)}
                />

                <DetailRow
                  title="Scheduled At"
                  value={
                    tripDetail.data?.scheduled_at
                      ? formatUTCDateToLocal(tripDetail.data.scheduled_at)
                      : "N/A"
                  }
                />

                <DetailRow
                  title="Started At"
                  value={
                    tripDetail.data?.started_at
                      ? formatUTCDateToLocal(tripDetail.data.started_at)
                      : "N/A"
                  }
                />

                <DetailRow
                  title="Ended At"
                  value={
                    tripDetail.data?.ended_at
                      ? formatUTCDateToLocal(tripDetail.data.ended_at)
                      : "In Progress"
                  }
                />
              </Col>

              {/* Driver & Vehicle */}
              <Col sm={12} md={6}>
                <h5 className="mb-3">Driver & Vehicle</h5>
                <div className="text-center">
                  <ZoomImage imageUrl={tripDetail.data?.driver?.image_url} />
                  <h6 className="mt-2">{tripDetail.data?.driver?.name}</h6>
                  <p className="text-muted">{tripDetail.data?.driver?.email}</p>
                </div>

                <div className="mt-3">
                  <DetailRow
                    title="Driver Mobile"
                    value={tripDetail.data?.driver?.mobile_no || "N/A"}
                  />
                  <DetailRow
                    title="Vehicle No"
                    value={tripDetail.data?.vehicle?.registration_number}
                  />
                  <DetailRow
                    title="Vehicle Type"
                    value={tripDetail.data?.vehicle?.vehicle_type}
                  />
                </div>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
};

export default TripDetailScreen;
